export interface StudentApplicationForm {
  prefix: string
  first_name: string
  last_name: string
  birth_date: string
  gender_id: string
  nationality_id: string
  email: string
  contact_number: string
  country_id: string
  city: string
  photo: string
  course_id: string
  how_did_you_hear: string
}

export const initialValues: StudentApplicationForm = {
  prefix: '',
  first_name: '',
  last_name: '',
  birth_date: '',
  gender_id: '',
  nationality_id: '',
  email: '',
  contact_number: '',
  country_id: '',
  city: '',
  photo: '',
  course_id: '',
  how_did_you_hear: '',
}
